import { GuidebookSummaryParlorContainer } from "containers/GuidebookSummaryContainer";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  const description =
    "보건복지부에서 발행한 <2022 장사업무 안내>를 참고한 장례식장에 대한 모든 정보.";

  return {
    props: {
      pageDescription: description,
      pageOgTitle: "장례식장 한눈에 보기 - [고이 장례 가이드북]",
      pageOgDescription: description,
      pageKeywords:
        "장례식장, 빈소, 납골당, 수목장, 화초장, 잔디장, 장례식장 비용, 화장장, 장례식장 추천",
    },
  };
};

interface Page {
  pageOgTitle: string;
}

function GuidebookSummaryParlor({ pageOgTitle }: Page) {
  return (
    <>
      <GuidebookSummaryParlorContainer />
    </>
  );
}

export default GuidebookSummaryParlor;
